angular.module('bmsApp.merrymaids.houseTemplate').controller('MMHouseTemplateIndexCtrl', [
    '$scope', '$state', '$cookies', 'ngTableParams', 'MMHouseTemplateSvc', function (
        $scope
      , $state
      , $cookies
      , ngTableParams
      , MMHouseTemplateSvc) {

        function defaultTableParams() {
            return {
                page: 1, // show first page
                count: $scope.config.table.params.count, // count per page
                filter: self.filter
            };
        }

        function initialParams() {
            if (angular.isDefined($cookies.MMHouseTemplateParams)) {
                return angular.extend({}, defaultTableParams(), JSON.parse($cookies.MMHouseTemplateParams));
            }
            else {
                return angular.extend({}, defaultTableParams());
            }
        }

        function init() {
            var params = initialParams();
            self.tableParams = new ngTableParams(params, {
                total: 0, // length of data
                counts: $scope.config.table.settings.counts, // available page counts
                getData: function ($defer, params) {
                    MMHouseTemplateSvc.index(params.$params)
                        .then(function (response) {

                            params.total(response.data.mm_house_templates_total);
                            self.totalCount = response.data.mm_house_templates_total;
                            $defer.resolve(response.data.mm_house_templates);

                        });
                }
            });
        }

    var self = $scope.MMHouseTemplateIndexCtrl = {
        methods: {
            init: init,
        },
        filter: {
            name: '',
        },
        totalCount: 0,
        tableParams: {}
    };

}]);